/* eslint-disable @typescript-eslint/naming-convention */
import { HttpErrorResponse } from '@angular/common/http';
import { FirebaseError } from '@angular/fire/app';
import { Action, createAction, createActionGroup, emptyProps, props } from '@ngrx/store';
import { CreateUserDto } from '../dtos/createUserDto.interface';
import { GetUserDto } from '../dtos/getUserDto.type';
import { UpdateUserDto } from '../dtos/updateUserDto.type';
import { IChangePasswordRequest } from '../interfaces/change-password-request.interface';
import { ILoginRequest } from '../interfaces/login-request.interface';
import { IResetUserRequest } from '../interfaces/reset-user-request.interface';
import { ISetOrResetPasswordRequest } from '../interfaces/set-or-reset-password-request.interface';
import { IUserPreferences } from '../interfaces/user-preferences.interface';
import { IVerifyOOBCode } from '../interfaces/verifyOOBCode.interface';
/**
 * The createAction function returns a function, that when called returns an object in the shape
 * of the Action interface. The props method is used to define any additional metadata needed
 * for the handling of the action.
 */

export const login = createActionGroup({
    source: '[Aumico-Users] Login',
    events: {
        do: props<{ payload: ILoginRequest }>(),
        success: emptyProps(),
        failure: props<{ payload: FirebaseError }>(),
    },
});

export const getCurrentUser = createActionGroup({
    source: '[Aumico-Users] GetCurrentUser',
    events: {
        do: emptyProps(),
        success: props<{ payload: GetUserDto }>(),
        failure: props<{ payload: HttpErrorResponse }>(),
    },
});

export const updateCurrentUser = createActionGroup({
    source: '[Aumico-Users] UpdateCurrentUser',
    events: {
        do: props<{ payload: UpdateUserDto }>(),
        success: props<{ payload: UpdateUserDto }>(),
        failure: props<{ payload: HttpErrorResponse }>(),
    },
});

export const setCurrentUser = createAction(
    '[Aumico-AnnualReport] setCurrentUser',
    props<{ payload: Partial<GetUserDto> }>(),
);

export const logout = createActionGroup({
    source: '[Aumico-Users] Logout',
    events: {
        do: emptyProps(),
        success: emptyProps(),
        failure: props<{ payload: HttpErrorResponse }>(),
    },
});

export const signup = createActionGroup({
    source: '[Aumico-Users] Signup',
    events: {
        do: props<{ createUserDto: CreateUserDto }>(),
        success: emptyProps(),
        failure: props<{ payload: HttpErrorResponse }>(),
    },
});

export const sendVerificationMail = createActionGroup({
    source: '[Aumico-Users] Send Verification Mail',
    events: {
        do: props<{ payload: string }>(),
        success: emptyProps(),
        failure: props<{ payload: HttpErrorResponse }>(),
    },
});
export const password = createActionGroup({
    source: '[Aumico-Users] Password',
    events: {
        Set: props<{ payload: ISetOrResetPasswordRequest }>(),
        Update: props<{ payload: ISetOrResetPasswordRequest }>(),
        Change: props<{ payload: IChangePasswordRequest }>(),
        'Set Success': emptyProps(),
        'Set Failed': props<{ payload: FirebaseError | HttpErrorResponse }>(),
        'Send Email For Reset': props<{ payload: IResetUserRequest }>(),
        'Send Email For Reset Success': emptyProps(),
        'Send Email For Reset Failed': props<{ payload: HttpErrorResponse }>(),
        'Change Success': emptyProps(),
        'Change Failed': props<{ payload: FirebaseError }>(),
    },
});

export const verifyOOBCode = createActionGroup({
    source: '[Aumico-Users] Verify OOB ',
    events: {
        do: props<{ payload: IVerifyOOBCode }>(),
        success: props<{ payload: string }>(),
        failure: props<{ payload: FirebaseError }>(),
    },
});

export const agreeToTerms = createActionGroup({
    source: '[Aumico-Users] Agree to terms',
    events: {
        do: emptyProps(),
        success: emptyProps(),
        failure: props<{ payload: HttpErrorResponse }>(),
    },
});

export const updateUserPreferences = createActionGroup({
    source: '[Aumico-Users] Update user preferences',
    events: {
        do: props<{ payload: IUserPreferences }>(),
        success: emptyProps(),
        failure: props<{ payload: HttpErrorResponse }>(),
    },
});

/**
 * Dispatch to pass payload, you can create parameterized Action in this way.
 */
export interface ActionWithPayload<T> extends Action {
    payload: T;
}
